jQuery(document).ready(function ($) {
    $('.faqs__question').on('click keydown', function (event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
            return;
        }
        if (event.type === 'keydown') {
            event.preventDefault();
        }

        $(this).find('.faqs__toggle').toggleClass('open');

        $(this).next().slideToggle(500);
    });
});